import { profile } from '../utils/session'

export function Leaderboard({ rows }) {
  const me = profile.value?.id

  return (
    <section class="leaderboard">
      <header class="calendar-head">
        <h2>Leaderboard</h2>
        <span class="muted">
          {rows.length} {rows.length === 1 ? 'persona' : 'personas'}
        </span>
      </header>
      <table>
        <thead>
          <tr>
            <th class="rank">#</th>
            <th>Nombre</th>
            <th class="num">Puntos</th>
            <th class="num">Racha máx.</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={row.id} class={row.id === me ? 'me' : ''}>
              <td class="rank muted">{i + 1}</td>
              <td class="name">
                {row.displayName}
                {row.completed && (
                  <span class="completed" title="Reto completado">✓</span>
                )}
                <span class="email muted">{row.email}</span>
              </td>
              <td class="num">{row.points}</td>
              <td class="num">{row.maxStreak}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  )
}
